/**
 * 记录各层级页面缓存
 * record page cache
 */

const cache = Object.create(null);
export default cache;
